<template>
  <div class="content">
    <md-card>
      <md-card-content>
        <b-container fluid>
          <!-- User Interface controls -->
          <b-row class="qidiruv">
            <b-col class="mb-2" lg="4" style="display: flex;">
              <b-button
                class="qoshishBtn"
                variant="primary"
                @click="createRoomLink"
              >
                <span>
                  <b-icon icon="plus-circle-fill" color="#fff"></b-icon>
                  {{ $t("Қўшиш") }}
                </span>
              </b-button>
              <b-button
                class="qoshishBtn ml-2"
                variant="primary"
                @click="DownloadTable"
              >
                <span>
                  <b-icon icon="cloud-download-fill" color="#fff"></b-icon>
                  {{ $t("Юклаш") }}
                </span>
              </b-button>
            </b-col>

            <b-col lg="6">
              <b-form-group
                label-for="filter-input"
                label-cols-sm="1"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    :placeholder="$t('Қидирув')"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      variant="danger"
                      @click="filter = ''"
                      >{{ $t("Тозалаш") }}</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <div class="tables">
            <b-table
              id="room-table"
              ref="refUserTable"
              hover
              sticky-header
              striped
              primary-key="id"
              :items="items"
              :fields="translatedFields"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
              :filter-included-fields="filterOn"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @row-clicked="RowClicked"
              sort-icon-left
              stacked="md"
              show-empty
              small
              @filtered="onFiltered"
            >
              <template #cell(№)="data" style="text-align: center;">
                {{ data.index + 1 }}
              </template>
              <template #cell(actions)="row" class="lg-1">
                <b-row class="ml-1">
                  <section
                    style="display: flex; justify-content: flex-end; width: 100%; margin-right: 30px"
                  >
                    <div style="display: flex; margin-right: 15px">
                      <b-button
                        variant="outline-primary"
                        @click="tekshiruvlarLink(row.item.id)"
                        class="pencil"
                      >
                        <b-icon
                          style="width: 15px;"
                          variant="outline-primary"
                          icon="pencil-fill"
                          aria-hidden="true"
                        ></b-icon>
                      </b-button>
                    </div>
                    <div>
                      <b-button
                        v-if="localUser.role != 'Loborant'"
                        class="trash"
                        style=""
                        variant="outline-danger"
                        >
                        <!-- @click="trash(row.item.id)" -->
                        <b-icon
                          style="width: 15px;"
                          icon="trash-fill"
                          aria-hidden="true"
                        ></b-icon>
                      </b-button>
                    </div>
                  </section>
                </b-row>
              </template>
            </b-table>
          </div>
          <div id="table-container">
            <div id="my-table">
              <div v-for="(item, index) in DownItems" :key="index">
                <table class="table table-sm table-bordered">
                  <tr style="text-align: center; font-size: 14pt;">
                    <td></td>
                    <td>
                      <b>{{ item.name }}</b>
                    </td>
                    <td></td>
                  </tr>
                  <tr
                    v-for="(itemCh, indCh) in item.type"
                    :key="indCh"
                    style="font-size: 14pt;"
                  >
                    <td>{{ indCh + 1 }}</td>
                    <td style="width: 700px;">{{ itemCh.name }}</td>
                    <td>{{ itemCh.price | numFormat }}</td>
                    <!-- <td>{{ itemCh.citizen_price | numFormat }}</td> -->
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <b-row>
            <b-col sm="6" offset-sm="3" md="6" offset-md="3" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-container>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "UserIndex",
  components: {},
  data() {
    return {
      items: [],
      DownItems: [],
      localUser: JSON.parse(localStorage.getItem("user")),
      fields: [
        "№",
        { key: "name", label: "Текширув номи", sortable: true },
        {
          key: "inspector_category.name",
          label: "Текширув бўлими",
          sortable: true
        },
        {
          key: "price",
          label: "Фуқаролик нарҳ",
          sortable: true,
          formatter: (value, key, item) => {
            let formatter = new Intl.NumberFormat("ru-RU", {
              minimumFractionDigits: 2
            });
            return formatter.format(value);
          }
        },
        // {
        //   key: "citizen_price",
        //   label: "Фуқаролиги бўлмаган нарҳ",
        //   sortable: true,
        //   formatter: (value, key, item) => {
        //     let formatter = new Intl.NumberFormat("ru-RU", {
        //       minimumFractionDigits: 2
        //     });
        //     return formatter.format(value);
        //   }
        // },
        { key: "actions", label: "" }
      ],
      translatedFields: [], // Initially empty
      totalRows: 1,
      currentPage: 1,
      perPage: 900,
      // pageOptions: [5, 10, 20, { value: 100, text: "Show a lot" }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: ["name"]
    };
  },
  watch: {
    "$i18n.locale": {
      immediate: true,
      handler() {
        this.updateTranslatedFields();
      }
    }
  },
  mounted() {
    this.updateTranslatedFields();
    this.data();
  },
  methods: {
    updateTranslatedFields() {
      this.translatedFields = this.fields.map(field => {
        return {
          ...field,
          label: this.$t(field.label)
        };
      });
    },
    RowClicked(item) {
      this.$router.push({ path: "tekshiruvlar-update/" + item.id });
    },
    tableToSheetData(table) {
      const rows = table.querySelectorAll("tr");
      const data = [];

      for (const row of rows) {
        const rowData = [];
        const cells = row.querySelectorAll("td, th");

        for (const cell of cells) {
          rowData.push(cell.innerText);
        }

        data.push(rowData);
      }

      return data;
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    async DownloadTable() {
      let x = [];
      await this.items.forEach(item => {
        const existingType = x.find(
          r => r.name === item.inspector_category.name
        );
        if (existingType) {
          if (item.type) {
            item.inspectionchild.forEach(el => {
              existingType.type.push(el);
            });
          } else {
            existingType.type.push(item);
          }
        } else {
          if (item.type) {
            let ch = [];
            item.inspectionchild.forEach(el => {
              ch.push(el);
            });
            x.push({ name: item.inspector_category.name, type: ch });
          } else {
            x.push({ name: item.inspector_category.name, type: [item] });
          }
        }
      });
      this.DownItems = x;

      try {
        // Dynamically load XLSX module
        const XLSX = await import(/* webpackChunkName: "xlsx" */ "xlsx");

        const tableContainer = document.getElementById("table-container");
        const table = document.getElementById("my-table");
        const sheetData = this.tableToSheetData(table);

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data");

        const excelData = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "binary"
        });

        const date = new Date()
          .toISOString()
          .slice(0, 19)
          .replace(/[-T]/g, "");
        const fileName = `Tekshiruvlar_${date}.xlsx`;
        const blob = new Blob([this.s2ab(excelData)], {
          type: "application/octet-stream"
        });

        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
        }
      } catch (error) {
        console.error("Error loading XLSX module:", error);
      }
      this.DownItems = [];
    },
    tekshiruvlarLink(id) {
      return this.$router.push({ path: "tekshiruvlar-update/" + id });
    },
    createRoomLink() {
      return this.$router.push({ path: "tekshiruvlar-create" });
    },
    data() {
      let s = this;
      axios({
        method: "get",
        url: "/inspection/all"
      }).then(res => {
        if (res) {
          s.items = res.data.data;
          s.totalRows = s.items.length;
        }
      });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    trash(id) {
      const trash = window.confirm(this.$t("Малумотлар ўчирилсинми?"));
      if (trash) {
        let self = this;
        axios({
          method: "delete",
          url: "/inspection/delete/" + id
        }).then(res => {
          if (res) {
            self.data();
          }
        });
      }
    }
  }
};
</script>
<style>
.qidiruv {
  display: flex;
  justify-content: space-between;
}
.tables {
  overflow-y: auto;
  overflow-x: hidden;
  height: 1000px;
}
.pencil {
  width: 35px;
  height: 35px;
  display: flex;
  background: #fff;
  border: 1px solid #e9f1fa;
  justify-content: center;
  border-radius: 50%;
  align-items: center;
}
.trash {
  background: #fff;
  width: 35px;
  height: 35px;
  display: flex;
  border: 1px solid #fff0f0;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
</style>
